
// roles definidos en variablesGlobals => ['superuser', 'accountmanager', 'finance', 'viewer', 'user', 'editorgames'];
// si no se define un rol, se supone que es público

export const permissions = {
  components: {
    navbars: {
      fantasyNabvar: {
        // '/home': ['superuser', 'accountmanager', 'finance', 'viewer', 'user', 'editorgames'],
        '/fantasy': ['superuser', 'accountmanager', 'finance', 'viewer', 'user'],
        // '/casino': ['superuser', 'accountmanager', 'finance', 'viewer', 'user', 'editorgames'],
        // '/campaigns': ['superuser', 'accountmanager', 'finance', 'viewer', 'user', 'editorgames'],
        '/administrators': ['superuser', 'accountmanager', 'finance'],
        '/users': ['superuser', 'accountmanager', 'finance', 'viewer', 'user'],
        // '/games': ['superuser', 'accountmanager', 'finance', 'viewer', 'user', 'editorgames'],
        '/providers': ['superuser', 'accountmanager', 'finance', 'viewer', 'user'],
        '/operators': ['superuser', 'accountmanager', 'finance', 'viewer', 'user'],
        '/finances': ['superuser', 'accountmanager', 'finance', 'viewer', 'user'],
      }
    }
  },
  views: {
    fantasy: {
      competitions: {
        createCompetition: ['superuser', 'accountmanager', 'finance'],
        editCompetition: ['superuser', 'accountmanager', 'finance'],
        toggleCompetition: ['superuser', 'accountmanager', 'finance'],
      },
      matchsets: {
        createMatchset: ['superuser', 'accountmanager', 'finance'],
        publicMatchset: ['superuser', 'accountmanager', 'finance'],
        loadMatchset: ['superuser', 'accountmanager', 'finance'],
        actionsMatchset: ['superuser', 'accountmanager', 'finance'],
        editMatchset: ['superuser', 'accountmanager', 'finance'],
      },
      matches: {
        bulkMatches: ['superuser', 'accountmanager', 'finance'],
        loadMatch: ['superuser'],
      },
      teams: {
        bulkTeams: ['superuser', 'accountmanager', 'finance'],
      },
      players: {
        bulkPlayers: ['superuser', 'accountmanager', 'finance'],
      },
      contests: {
        createContest: ['superuser', 'accountmanager', 'finance'],
        editContest: ['superuser', 'accountmanager', 'finance'],
        actionsContest: ['superuser', 'accountmanager', 'finance'],
      },
      networks: {
        createNetwork: ['superuser', 'accountmanager', 'finance'],
        editNetwork: ['superuser', 'accountmanager', 'finance'],
        toggleNetwork: ['superuser', 'accountmanager', 'finance'],
      },
    },
    casino: {
      freespins: {
        createFreespins:  ['superuser', 'accountmanager', 'finance'],
      },
      lobby: {
        createLobby:  ['superuser', 'accountmanager', 'finance'],
        editLobby:  ['superuser', 'accountmanager', 'finance'],
      },
      freerounds: {
        createLobby:  ['superuser', 'accountmanager', 'finance', 'editorgames'],
        editLobby:  ['superuser', 'accountmanager', 'finance', 'editorgames'],
      },
    },
    // campaigns: {     // TODO, pendiente
    // },
    administrators: {
      createAdministrator:  ['superuser', 'accountmanager', 'finance'],
      editAdministrator:  ['superuser', 'accountmanager', 'finance'],
    },
    games: {
      createGame:  ['superuser', 'accountmanager', 'finance', 'editorgames'],
      editGame:  ['superuser', 'accountmanager', 'finance', 'editorgames'],
      toggleGame:  ['superuser', 'accountmanager', 'finance', 'editorgames'],
    },
    rounds: {
      toggleRound:  ['superuser', 'accountmanager', 'finance'],
    },
    providers: {
      createProvider:  ['superuser', 'accountmanager', 'finance'],
      editProvider:  ['superuser', 'accountmanager', 'finance'],
      toggleProvider:  ['superuser', 'accountmanager', 'finance'],
    },
    operators: {
      createOperator:  ['superuser', 'accountmanager', 'finance'],
      editOperator:  ['superuser', 'accountmanager', 'finance'],
      toggleOperator:  ['superuser', 'accountmanager', 'finance'],
    },
    categories: {
      createCategory:  ['superuser', 'accountmanager', 'finance'],
      editCategory:  ['superuser', 'accountmanager', 'finance'],
    },
    finances: {
      createInvoice:  ['superuser', 'accountmanager', 'finance'],
    },
  },
};
